export const VALIDATE_FORM = 'VALIDATE_FORM';
export const VALIDATE_FORM_FAILURE = 'VALIDATE_FORM_FAILURE';
export const VALIDATE_FORM_SUCCESS = 'VALIDATE_FORM_SUCCESS';

export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SUBMIT_FORM_FAILURE = 'SUBMIT_FORM_FAILURE';
export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';
